/**
 * @generated SignedSource<<bce801ed27566dd6b88c72a0a9e5fa88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionDataFragmentRefetchQuery$variables = Record<PropertyKey, never>;
export type SubscriptionDataFragmentRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSubscriptionData_subscriptionDataFragment">;
};
export type SubscriptionDataFragmentRefetchQuery = {
  response: SubscriptionDataFragmentRefetchQuery$data;
  variables: SubscriptionDataFragmentRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionDataFragmentRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useSubscriptionData_subscriptionDataFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscriptionDataFragmentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPantoneEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSinglePrintFileEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCmykEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPdfEpsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAdvancedPricingEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isProfanityChecksEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOnCustomPlan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "areSalesChannelsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inTrial",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingTrialDays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PlanGraphql",
            "kind": "LinkedField",
            "name": "plan",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSizeStorageMB",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salesChannelPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCustom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AdditionalPlanFeatures",
                "kind": "LinkedField",
                "name": "additionalFeatures",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editPDFPreview",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editSummary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integrations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bulkVariationForm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pricePerImage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "engraving",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editPrintfiles",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "printReadyFilesPlus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "textplus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prices3dConfigurator",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customEnvironmentTexture",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dynamicProperties",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "materialLibrary",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "multiareaConfiguratorDesigner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "advancedPrintFilesBuilder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aiPoweredTools",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "getAQuote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customInterface",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profanityFilter",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "largeFile",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "configuratorLinks",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vectorization",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moq",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionAddon",
            "kind": "LinkedField",
            "name": "addons",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addonID",
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketplace",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "ignoreNoneECommerce",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "status",
            "value": "ACTIVE"
          }
        ],
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteUrl",
                "storageKey": null
              },
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShopifyAuthEcommerceSettings",
        "kind": "LinkedField",
        "name": "shopifyAuthEcommerceSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "environment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "installed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTestStore",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shop",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "915829c6d9e66e87ba76d545e45a266e",
    "id": null,
    "metadata": {},
    "name": "SubscriptionDataFragmentRefetchQuery",
    "operationKind": "query",
    "text": "query SubscriptionDataFragmentRefetchQuery {\n  ...useSubscriptionData_subscriptionDataFragment\n}\n\nfragment useSubscriptionData_subscriptionDataFragment on Query {\n  subscription {\n    planName\n    planVersion\n    profileDescription\n    profileName\n    isPantoneEnabled\n    isSinglePrintFileEnabled\n    isCmykEnabled\n    isPdfEpsEnabled\n    isAdvancedPricingEnabled\n    isProfanityChecksEnabled\n    isOnCustomPlan\n    areSalesChannelsEnabled\n    inTrial\n    remainingTrialDays\n    plan {\n      name\n      description\n      version\n      currencyCode\n      maxSizeStorageMB\n      salesChannelPrice\n      isCustom\n      additionalFeatures {\n        editPDFPreview\n        editSummary\n        integrations\n        bulkVariationForm\n        pricePerImage\n        engraving\n        editPrintfiles\n        printReadyFilesPlus\n        textplus\n        prices3dConfigurator\n        customEnvironmentTexture\n        dynamicProperties\n        materialLibrary\n        multiareaConfiguratorDesigner\n        advancedPrintFilesBuilder\n        aiPoweredTools\n        getAQuote\n        customInterface\n        profanityFilter\n        largeFile\n        configuratorLinks\n        vectorization\n        moq\n      }\n      id\n    }\n    addons {\n      addonID\n      name\n      startDate\n      id\n    }\n    id\n  }\n  ecommerceSettings {\n    ecommerceName\n    id\n  }\n  seller {\n    marketplace\n    id\n  }\n  salesChannels(status: ACTIVE, ignoreNoneECommerce: true) {\n    id\n    ecommerceSettings {\n      ecommerceName\n      isMarketplace\n      remoteUrl\n      currencyCode\n      id\n    }\n  }\n  shopifyAuthEcommerceSettings {\n    environment\n    installed\n    isTestStore\n    shop\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ea12bec5922568849a2c88077c89e64";

export default node;
